module.exports = __webpack_public_path__ + "static/media/Design Custom Emoji.70af5bce.png";